import React from 'react';

import { __ } from '../../lib/I18n';

/**
 * @typedef {{
 *  onClick?: () => void,
 *  content?: string,
 *  interval: number,
 *  onFinishTimer?: () => void,
 *  textColor?: string
 * }} Props
 * @extends {React.Component<Props>}
 */
export default class Timer extends React.Component {
  state = {
    elapsed: 0,
    date: Date.now()
  }

  componentDidMount() {
    this.timer = setInterval(this.tick, 50);
  }

  componentWillUnmount() {
    if (this.timer) clearInterval(this.timer);
  }

  tick = () => {
    const { date } = this.state;
    //@ts-ignore
    const elapsed = new Date() - (this.props.start || date);

    this.setState({ elapsed }, () => {
      if ((elapsed / 1000) >= this.props.interval) {
        if (this.timer) clearInterval(this.timer);
      }
    });
  }

  render() {
    const { onClick, content, interval, onFinishTimer, textColor } = this.props;
    const elapsed = Math.round(this.state.elapsed / 100);
    const seconds = (elapsed / 10).toFixed(1);
    //@ts-ignore
    const countdown = (interval - seconds).toFixed(0);

    //@ts-ignore
    if (seconds >= interval) {
      if (onFinishTimer) onFinishTimer();
      return (
        <span
          style={{ color: (textColor || '#0080ff') }}
          className="pointer"
          onClick={() => {
            if (onClick) onClick();
            this.setState({ date: new Date() }, () => {
              this.timer = setInterval(this.tick, 50);
            });
          }}
        >
          {content}
        </span>
      );
    }

    return (
      <span style={{ color: (textColor || '#0080ff'), opacity: '.6' }}>
        {/** @ts-ignore */}
        {__('Aguarde %s %s para solicitar novo código.', countdown, countdown > 1 ? __('segundos') : __('segundo'))}
      </span>
    );
  }
}
